var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useMetadataModel())?_c('MyPointsMetadataModel',{attrs:{"customItems":_vm.customItems}}):_c('MyPointsDefaultModel',{attrs:{"customItems":_vm.customItems}})}
var staticRenderFns = []

export { render, staticRenderFns }